import React from "react"
import { css } from "@emotion/core"
import ProductLink from "./product_link"

class Recommendation extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div
        css={css`
          background-color: #fff;
          margin-bottom: 40px;
          border-radius: 3px;
          border: 1px solid #aaa;

          user-select: none;

          display: flex;

          padding: 20px 20px 30px 20px;
          @media only screen and (max-width: 576px) {
            padding: 20px;
          }
        `}
      >
        <div
          css={css`
            flex: 1;
            margin-right: 10px;
          `}
        >
          <ProductLink
            href={this.props.href}
            css={css`
              width: 100%;
              height: 100%;

              flex-direction: column;
              justify-content: center;
              display: flex;
            `}
          >
            <img
              css={css`
                display: block;
                margin: 0;
                padding: 30px;
              `}
              src={this.props.image}
            />
          </ProductLink>
        </div>
        <div
          css={css`
            flex: 1;
            margin-left: 10px;
          `}
        >
          <div
            css={css`
              font-weight: 600;
              font-size: 18px;
              margin-bottom: 12px;
            `}
          >
            Our Recommendation
          </div>
          <ProductLink
            href={this.props.href}
            css={css`
              font-weight: 600;
              font-size: 22px;
              color: #473dc7;
              margin-bottom: 6px;
              display: inline-block;
              text-decoration: underline;

              :hover {
                color: #30298e;
                cursor: pointer;
              }
            `}
          >
            {this.props.product}
          </ProductLink>

          <div
            css={css`
              font-weight: 600;
              margin-bottom: 18px;
            `}
          >
            {this.props.tagline}
          </div>

          <div
            css={css`
              font-size: 15px;
              line-height: 20px;
              margin-bottom: 18px;
            `}
          >
            {this.props.description}
          </div>
          <ProductLink
            href={this.props.href}
            css={css`
              font-weight: 500;
              font-size: 16px;
              line-height: 16px;
              color: #fff;
              display: inline-block;
              text-decoration: none;
              background-color: #473dc7;
              padding: 10px 20px;
              border-radius: 8px;

              width: 100%;
              text-align: center;

              cursor: pointer;

              transition-property: color, background-color;
              transition-duration: 0.08s;

              :hover {
                color: #fff;
                background-color: #30298e;
              }
            `}
          >
            {this.props.link_label}
          </ProductLink>
        </div>
      </div>
    )
  }
}

export default Recommendation
